import { useMemo } from 'react';
import * as yup from 'yup';
import {
  Adventure,
  JoinAdventureParams,
  useAdventure,
  useAdventureNextPrice,
} from '~/components/Adventure/Adventure.hooks';

export type JoinAdventureValues = {
  balance: number;
} & Pick<JoinAdventureParams, 'count'>;

export const useAdventureSchema = (id: Adventure['id']) => {
  const { data: { participation } = {} } = useAdventure(id);
  const nextPrice = useAdventureNextPrice(id);
  const { maxCount = 12, currentCount = 0 } = participation || {};
  return useMemo(
    () =>
      yup.object({
        balance: yup.number().required(),
        count: yup
          .number()
          .min(1, 'MIN_COUNT')
          // 이전 참여 횟수 + 참여 시도 횟수가 12 이상일 경우
          .test({
            name: 'MAX_COUNT',
            message: 'MAX_COUNT',
            test: (value = 0) => currentCount + value <= maxCount,
          })
          // 보유한 DON보다 많이 참여하려는 경우
          .test({
            name: 'NOT_ENOUGH_BALANCE',
            message: 'NOT_ENOUGH_BALANCE',
            test: (value = 0, testContext) => value * nextPrice <= testContext.parent.balance,
          })
          .required(),
      }),
    [currentCount, maxCount, nextPrice]
  );
};
